import React, {Component} from 'react'
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap"
import {ReactComponent as IconHead} from "../../../assets/icon/icon-head.svg"
import {forecastShipBatchStatistics} from "../../../services/api/apiBarcode"
import Table from './Table'
import downloadCsv from '../../../components/ExportCSV/downloadCsv'
import moment from 'moment'

class ForecastShipBatchPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            mappingCarriers: [],
            notShipped: {},
            overdue: {},
            expectedCompletion: [],
            containerRows: false,
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {data: response} = await forecastShipBatchStatistics()
            const {
                success,
                data: {
                    mappingCarriers,
                    notShipped,
                    overdue,
                    expectedCompletion,
                    totalOrders,
                    totalWeight,
                },
                message,
            } = response


            return this.setState({
                loading: false,
                error: !success ? message : '',
                mappingCarriers,
                notShipped,
                overdue,
                expectedCompletion,
                totalOrders,
                totalWeight,
            })
        } catch (e) {
            console.log(e)
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    setContainerRows = (containerRows) => this.setState({containerRows})

    export = () => {
        const body = this.state.containerRows.current

        const csv = []
        const rows = [...body.getElementsByTagName('tr')]
        let carrier

        rows.forEach(row => {
            const cols = [...row.getElementsByTagName('td')]
            const rowData = {}
            cols.forEach(col => {
                const prop = col.getAttribute('data-col')
                rowData[prop] = `${col.textContent}`
                    .replace(/^(\s|\t|\n)/, '')
                    .replace(/(\s|\t|\n)$/, '')

                if (prop === 'shipping_carrier') {
                    carrier = rowData[prop]
                }
            })

            if (!rowData['shipping_carrier']) {
                rowData.shipping_carrier = carrier
            }

            csv.push(rowData)
        })
        const mapCols = {
            shipping_carrier: '"Shipping Carrier"',
            order_weight: '"Đơn / Kg"',
            not_shipped: '"Chưa ship"',
            overdue: '"Quá hạn sx"',
            total: '"Tổng"',
            ...(Array.from({length: 6}).reduce((mem, _undef, i) => {
                return {
                    ...mem,
                    [`date_${i}`]: i === 0 ? '"Hôm nay"' : `"${moment().add(i, 'd').format('DD/MM/YYYY')}"`,
                }
            }, {})),
        }

        downloadCsv(csv, {
            mapCols,
        })
    }

    render() {
        const {
            loading,
            error,
            containerRows,
        } = this.state

        return (
            <Row className="text-center">
                <Col md={12} className="Left">
                    <div className="ForecastShipBatchPage">
                        <Card>
                            <CardHeader
                                className="d-flex align-items-center justify-content-start bg-warning text-dark header-elements-inline">
                                <h2 className="card-title d-flex align-items-center">
                                    <IconHead/>
                                    <span className="ml-2">Dự báo tổng khối lượng ship lô theo ngày</span>
                                    <i className={['BtnRefresh fa fa-refresh', loading && 'disabled spinner'].filter(Boolean).join(' ')}
                                       onClick={this.fetchData} title={'Tải lại'}/>
                                    <button type="button"
                                            className="btn btn-primary BtnExport"
                                            disabled={!containerRows}
                                            onClick={this.export}>Export
                                    </button>
                                </h2>
                            </CardHeader>
                            <CardBody>
                                {loading && <span className="ml-2 pt-1">Loading...</span>}
                                {
                                    !loading && !error &&
                                    <Table {...this.state} setContainerRows={this.setContainerRows}/>
                                }
                                {
                                    !loading && error && <p className="ml-2 pt-1 error">{error}</p>
                                }
                            </CardBody>
                        </Card>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default ForecastShipBatchPage
